// extracted by css-extract-rspack-plugin
module.exports =  {"spinner":"ModalSpinner__spinner___leFL7"};